export const SPECIALTIES = 'md_specialties_GLOBAL';